import { useEffect } from 'react';

/**
 * useAbortEffect with AbortController injection to fetch request:
 *
 * @param {Function} fetchCallback - Callback. Fetch request function.
 * @param {Array} dependencies - (Optional) Array. Dependencies array to trigger the callback.
 *
 */

export default function useAbortEffect(fetchCallback, dependencies = []) {
  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    // Execute the fetch request
    fetchCallback(signal);

    // Cleanup function to abort the previous fetch request when dependencies change
    return () => {
      abortController.abort();
    };
  }, dependencies);
}
